define([], function(){

	function select_menu(menu_id, id){
		var menu = $$(menu_id);
		if (!menu) {
			return;
		}
		if (menu.setValue) {
            menu.setValue(id);
		} else if (menu.select && menu.exists(id)) {
            menu.select(id);
		}
	}

	function get_menu(scope){
		if (scope.parent)
			return scope.parent.module.$menu || get_menu(scope.parent);
	}

	function get_leaf_page(name, stack){
		if (stack && stack.length)
			return stack[stack.length - 1].page;
		return name ? name.page : null;
	}

	function update_title(pageId){
		if (!pageId || pageId === "app")
			return;

		var titleView = $$("title");
		if (!titleView)
			return;

		var item = null;
		var menu = $$("app:menu");
		if (menu && menu.exists && menu.exists(pageId))
			item = menu.getItem(pageId);

		if (!item && typeof APPLOCALE !== "undefined" && APPLOCALE.mainMenu && APPLOCALE.mainMenu[pageId])
			item = {
				value: APPLOCALE.mainMenu[pageId].name,
				details: APPLOCALE.mainMenu[pageId].detail
			};

		if (item && item.value)
			titleView.parse({title: item.value, details: item.details || ""});
	}

	return {
        get_menu: get_menu,
		$onurlchange:function(ui, name, url, scope){
			if (!ui || !ui.$menuid)
				return;
			var id = ui.$menuid.call ? ui.$menuid.call(ui, ui, name, url) : ui.$menuid;
			var menu = get_menu(scope);
			if (menu && id)
				select_menu(menu, id);
		},

		$onui:function(ui, name, url, scope){
			var pageId = get_leaf_page(name, url);
			update_title(pageId);

			var menuId = (ui && ui.$menu) || get_menu(scope);
			if (menuId && pageId && pageId !== "app")
				select_menu(menuId, pageId);
		}
	};
});